exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paddle-checkout{border-radius:4px;max-width:450px;width:100%}.paddle-checkout__wrapper{max-width:450px;width:100%}\n", ""]);

// exports
exports.locals = {
	"paddle-checkout": "paddle-checkout",
	"paddle-checkout__wrapper": "paddle-checkout__wrapper"
};